import { getCanonicalAuthUserId } from "./authIdentity";
import { safeSessionStorage } from "../utils/safeStorage";

const RECOVERY_KEY = "loginPasswordRecoveryUid";

export const requestLoginPasswordRecovery = (user) => {
  const uid = getCanonicalAuthUserId(user);
  if (uid) safeSessionStorage.setItem(RECOVERY_KEY, uid);
};

export const hasLoginPasswordRecovery = (user) => {
  const uid = getCanonicalAuthUserId(user);
  return Boolean(uid && safeSessionStorage.getItem(RECOVERY_KEY) === uid);
};

export const clearLoginPasswordRecovery = (user = null) => {
  if (!user || hasLoginPasswordRecovery(user)) {
    safeSessionStorage.removeItem(RECOVERY_KEY);
  }
};
